import { forwardRef } from 'react';

function r(o){return forwardRef(o)}

export { r as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-TWGPE4V7.js.map